import { createRedesignEntry } from "../redesign-page-entry";

/**
 * Lazy entry for the redesign-v1 payments page — shell is eager; only the page body is code-split.
 */
export default createRedesignEntry(() => import("./payments-page"), {
  testId: "rd-payments-loading",
  shell: { activeNav: "payments" },
});
